import { render, staticRenderFns } from "./MMAdetail.vue?vue&type=template&id=7781849d&scoped=true"
import script from "./MMAdetail.vue?vue&type=script&lang=js"
export * from "./MMAdetail.vue?vue&type=script&lang=js"
import style0 from "./MMAdetail.vue?vue&type=style&index=0&id=7781849d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7781849d",
  null
  
)

export default component.exports